import {EntityInfoWindow, EntityInfoWindowProps} from "../EntityInfoWindow/EntityInfoWindow";
import {TransportEntity} from "@ots-frontend/ots-data";
import {useTranslation} from "react-i18next";
import {Text} from "@mantine/core";
import {getFormattedDateTime} from "../../../date/FormattedDateTime/FormattedDateTime";
import {getFormattedQuantity} from "../../../text/FormattedQuantity/FormattedQuantity";
import {getFormattedDatabaseCode} from "../../../text/FormattedDatabaseCode/FormattedDatabaseCode";
import {DefaultText} from "../../../text/DefaultText/DefaultText";

export type TransportInfoWindowProps = EntityInfoWindowProps<TransportEntity>

export const TransportInfoWindow = (props: TransportInfoWindowProps) => {
  const {entity: transport, ...rest} = props;

  const {t} = useTranslation("common");

  return (
    <EntityInfoWindow {...rest} entity={transport}>
      <Text>
        {t("ots.ui.entity.transport.map.infowindow.title", "{{type}} of {{qty}} {{freightTypeName}}", {
          type: getFormattedDatabaseCode(transport.type, t),
          qty: getFormattedQuantity(transport.quantityDecimal, transport.quantityUnitOfMeasure),
          freightTypeName: transport.waterTypeName ?? t("common.shared.unknown", "Unknown")
        })}
      </Text>
      {transport.serviceTypeId &&
        <Text c="service-work">
          <DefaultText value={transport.serviceTypeName}/>
        </Text>
      }
      <Text>
        {
          t("common.entity.transport.map.infowindow.site", "Site: {{siteName}}", {
            siteName: transport.siteName ?? '-'
          })
        }
      </Text>
      <Text>
        {
          t("common.entity.transport.map.infowindow.dttm", "Date: {{date}}", {
            date: transport.createDttm ? getFormattedDateTime(transport.createDttm) : '-'
          })
        }
      </Text>
    </EntityInfoWindow>
  );
};
